import React, { useEffect, useState } from 'react';

import RenderFieldBasedOnType from '../RenderFieldsBasedOnType';
import {
    Box,
    Grid,
    Typography,
    Tooltip
} from '@material-ui/core'
import { Helpers } from "dsilo-ui-components";
import { makeStyles } from '@material-ui/core/styles';
import SubDataModelTaskViewer from "../SubDataModelTask"

const useCommonStyles = makeStyles((theme) => ({
    statusDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        border: '1px solid #ddd',
        alignItems: 'center',
        borderRadius: 4,
        padding: 5,
        marginTop: 10,
        fontSize: 13,
    },
    statusDivAction: {
        display: 'flex',
        alignItems: 'center',
    },
    rootContainer: {
        marginTop: "20px"
    },
    titleBlock: {
        display: "flex",
        alignItems: "center"
    },
    title: {
        fontWeight: "bold",
        fontSize: "14px"
    },
    addIcon: {
        marginLeft: "8px",
        cursor: "pointer"
    },
    tableHeaderCell: {
        // borderBottom:"none"
    },
    tableActions: {
        display: "flex",
        alignItems: "center"
    },
    actionIcon: {
        cursor: "pointer"
    },
    inputField: {
        width: "100%",
        height: "35px",
        paddingLeft: "5px"
    },
    selectField: {
        height: "35px",
    },

    columnContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        [theme.breakpoints.down('md')]: { gap: 8 },
        [theme.breakpoints.down('sm')]: { gap: 6 },
    },
    sectionTitleText: {
        fontWeight: 400,
        fontSize: 14,
        color: 'rgba(43, 44, 53, 1)',
        fontStyle: 'normal',
        lineHeight: '21px',
        [theme.breakpoints.down('md')]: { fontSize: 13.5, lineHeight: '20px' },
        [theme.breakpoints.down('sm')]: { fontSize: 13, lineHeight: '19px' },
    },
    sectionTitleTextClamp: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        maxWidth: 300, // base desktop ≥1280px
        [theme.breakpoints.down('lg')]: { maxWidth: 260 },  // 960px–1279px
        [theme.breakpoints.down('md')]: { maxWidth: 220 },  // 600px–959px
        [theme.breakpoints.down('sm')]: { maxWidth: 180 },  // <600px
        [theme.breakpoints.down('xs')]: { maxWidth: 150 },
    },

    fieldLabelClamp: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        maxWidth: 300, // base desktop ≥1280px
        [theme.breakpoints.down('lg')]: { maxWidth: 100 },   // 👈 match your CSS: at ≤1279px shrink to 50px
        [theme.breakpoints.down('md')]: { maxWidth: 80 },   // further tighten at ≤959px
        [theme.breakpoints.down('sm')]: { maxWidth: 30 },   // phones ≤599px
        [theme.breakpoints.down('xs')]: { maxWidth: 25 },   // very small
    },
    gridItemMargins: {
        marginTop: 2,
        marginBottom: 2,
    },
    fullWidthBox: {
        width: '100%',
    },
    labelRow: {
        display: 'flex',
        alignItems: 'center',
    },
    fieldLabel: {
        fontWeight: 400,
        fontSize: 12,
        color: 'rgba(120, 121, 142, 1)',
        fontStyle: 'medium',
        [theme.breakpoints.down('md')]: { fontSize: 11.5 },
        [theme.breakpoints.down('sm')]: { fontSize: 11 },
    },
    // fieldLabelClamp: {
    //     display: 'inline-block',
    //     verticalAlign: 'bottom',
    //     overflow: 'hidden',
    //     textOverflow: 'ellipsis',
    //     whiteSpace: 'nowrap',
    //     maxWidth: 280,
    //     [theme.breakpoints.down('lg')]: { maxWidth: 240 },
    //     [theme.breakpoints.down('md')]: { maxWidth: 200 },
    //     [theme.breakpoints.down('sm')]: { maxWidth: 160 },
    //     [theme.breakpoints.down('xs')]: { maxWidth: 120 },
    // },
    fieldWrapper: {
        marginTop: 4,
        width: '100%',
    },
}));

const useInputStyles = makeStyles((theme) => ({
    smallOutlinedInput: {
        fontSize: '12px',
        height: '32px',
        padding: '5px 8px 6px 8px',
        '& input': {
            padding: '5px 6px 6px 6px',
            fontSize: '12px',
        },
        "&.Mui-disabled": {
            color: "#5F6071",
        },
        [theme.breakpoints.down('md')]: {
            height: '30px',
            padding: '5px 8px',
            '& input': { padding: '5px 6px' },
        },
        [theme.breakpoints.down('sm')]: {
            height: '28px',
            padding: '4px 8px',
            '& input': { padding: '4px 6px' },
        },
    },
    smallNotchedOutline: {
        fontSize: '12px',
        borderColor: '#ccc',
        [theme.breakpoints.down('sm')]: { fontSize: '11.5px' },
    },
}));

/* For now It is static */
const defaultOptions = {}

const SummaryBlock = (props) => {
    const layoutClasses = useCommonStyles()
    const inputClasses = useInputStyles();

    const { currentDocumentId, formData, selectedStep, block, blockState, handleCheckboxChange, onChange } = props
    const { chartUniqueId } = props.data

    const [blockHeaders, setBlockHeaders] = useState([])
    const [allTasksCompleted, setAllTasksCompleted] = useState(false);
    const shouldDisableFields = props.shouldDisableFields

    useEffect(() => {
        if (formData?.dataModel[selectedStep.dataModel]) {
            let dataElements = formData.dataModel[selectedStep.dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                if (block?.config?.dataElements) {
                    fdes = JSON.parse(JSON.stringify(block?.config?.dataElements))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        if (sde?.name) {
                            return { ...sde, ...fde }
                        } else {
                            return fde
                        }
                    })
                    setBlockHeaders(fdes)
                }
            }
        }
    }, [formData?.dataModel])

    const showHideWorkFlow = (obj) => {
        setAllTasksCompleted(obj)
        props.showHideWorkFlow(obj)
    }

    return (
        <React.Fragment>
            <div className={layoutClasses.columnContainer}>
                <Tooltip title={block?.name || ''} arrow>
                    <Typography
                        component='span'
                        noWrap
                        className={`${layoutClasses.sectionTitleText} ${layoutClasses.sectionTitleTextClamp}`}
                    >
                        {block.name} :
                    </Typography>
                </Tooltip>

                <Grid container spacing={1}>
                    {
                        blockHeaders?.length > 0 ? blockHeaders.map((element, index) => {
                            const isFieldReadOnly = shouldDisableFields || element.readOnly;

                            return (
                                <Grid
                                    item
                                    key={index}
                                    xs={element.xs ? element.xs : (12 / blockHeaders.length)}
                                    className={layoutClasses.gridItemMargins}
                                >
                                    {
                                        element?.isCustomType?.enable === true && element?.isCustomType?.type === "linkedReferenceTasks" ? (
                                            <SubDataModelTaskViewer {...props} element={element} eachBlock={element?.isCustomType} block={element?.isCustomType} keyName={element?.isCustomType?.dataModel} currentOpportunityId={currentDocumentId} shouldDisableFields={shouldDisableFields} showHideWorkFlow={showHideWorkFlow} />
                                        ) : (
                                            <Box className={layoutClasses.fullWidthBox}>
                                                <Grid container>
                                                    <div className={layoutClasses.labelRow}>
                                                        <Tooltip title={element?.label || ''} arrow>
                                                            <Typography
                                                                component='span'
                                                                className={`${layoutClasses.fieldLabel} ${layoutClasses.fieldLabelClamp}`}
                                                            >
                                                                {element.label} :
                                                            </Typography>
                                                        </Tooltip>
                                                    </div>

                                                    <div className={layoutClasses.fieldWrapper}>
                                                        <RenderFieldBasedOnType
                                                            {...props}
                                                            classes={layoutClasses}
                                                            element={isFieldReadOnly ? { ...element, readOnly: true } : element}
                                                            onChange={onChange}
                                                            handleCheckboxChange={handleCheckboxChange}
                                                            dataObj={blockState}
                                                            options={defaultOptions[element.value || element.name]}
                                                            selectedStep={selectedStep}
                                                            inputClasses={inputClasses}
                                                        />
                                                    </div>
                                                </Grid>
                                            </Box>
                                        )
                                    }
                                </Grid>
                            )
                        }) : (
                            <Typography>{`No Fields are Configured`}</Typography>
                        )
                    }
                </Grid>
            </div>
        </React.Fragment>
    )
}

export default SummaryBlock
